<template>
	<div :class="{ 'hidden': !showModal, 'main-modal': true }">
		<div class="main-modal-header">
			<div class="main-modal-right">
				<button @click="closeMarking">
					<b-icon icon="chevron-down"></b-icon>
				</button>
			</div>
		</div>
		<div class="main-modal-content">
			<h2>{{competencytestmarking.Code}}: {{competencytestmarking.Name}}</h2>

			<div class="row">

				<div class="col-12 col-lg-4 order-lg-2">
					<div class="card mb-8">
						<div class="card-header">
							<label>{{ $t('outcome') }}</label>
						</div>
						<div class="card-body">
							<div class="form-group clear-left">
								<div class="btn-group">
									<button
										class="btn"
										v-bind:class="{
											'btn-on': competencytestmarking.CurrentHasPassed === 1,
                                            'btn-on-good': !this.$config.getValue('testsoftmarking'),
											'btn-off': competencytestmarking.CurrentHasPassed !== 1
										}"
										@click="togglePassed(1)"
										:disabled="readonly"
									>
										{{ getDichotomy('true') }}
									</button>
									<button
										class="btn"
										v-bind:class="{
											'btn-on': competencytestmarking.CurrentHasPassed === 0,
                                            'btn-on-bad': !this.$config.getValue('testsoftmarking'),
											'btn-off': competencytestmarking.CurrentHasPassed !== 0
										}"
										v-on:click="togglePassed(0)"
										:disabled="readonly"
									>
										{{ getDichotomy('false') }}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-8 order-lg-1">
					<template v-if="competencytestmarking.form">
						<template v-for="(page, pageIndex) in competencytestmarking.form.pages">
							<div class="card mb-8" :key="pageIndex">
								<div class="card-header">
									<label>{{ page.title }}</label>
								</div>

								<div class="card-body">
									<FormGrid :page="page" :readonly="readonly" :viewAs="viewAs"></FormGrid>
								</div>
							</div>
						</template>
					</template>

					<div class="card mb-8">
						<div class="card-header">
							<label>{{ $t('outcome') }}l</label>
						</div>
						<div class="card-body">
							<div class="form-group clear-left">
								<div class="btn-group">
									<button
										class="btn"
										v-bind:class="{
											'btn-on btn-on-good': competencytestmarking.CurrentHasPassed === 1,
											'btn-off': competencytestmarking.CurrentHasPassed !== 1
										}"
										@click="togglePassed(1)"
										:disabled="readonly"
									>
										{{ getDichotomy('true') }}
									</button>
									<button
										class="btn"
										v-bind:class="{
											'btn-on btn-on-bad': competencytestmarking.CurrentHasPassed === 0,
											'btn-off': competencytestmarking.CurrentHasPassed !== 0
										}"
										v-on:click="togglePassed(0)"
										:disabled="readonly"
									>
										{{ getDichotomy('false') }}
									</button>
								</div>
							</div>
						</div>
					</div>

			</div>

			</div>

		</div>
	</div>
</template>

<script>
import FormGrid from "src/components/FormEditor/FormGrid";
export default {
	name: "treatmentsessionselectcompetencytestmarking",
	components: {
		FormGrid
	},
	props: {
		showcompetencytestmarking: Boolean,
		competencytestmarking: Object,
		readonly: Boolean,
		canmark: Boolean
	},
	data: function () {
		return {
		}
	},
	computed: {
		showModal: function() {
			if(this.showcompetencytestmarking){
				return true;
			}
			return false;
		},
		viewAs: function() {
			// canmark reflects the marker actually authorized right now, which on a shared
			// device is the teacher who logged in via the treatment session's teacher-login
			// prompt, not $UserSession (which stays the student for the whole handoff).
			if(this.canmark){
				return 'editall';
			}
			return 'submitter';
		}
	},
	methods: {
		closeMarking: function() {
			this.$emit('hideCompetencyTestMarking');
		},
		togglePassed(passed) {
			if (this.competencytestmarking.CurrentHasPassed !== passed) {
				this.competencytestmarking.CurrentHasPassed = passed;
			} else {
				this.competencytestmarking.CurrentHasPassed = -1;
			}
		},
		getDichotomy(type){
			if(this.$config.getValue('dichotomies') && this.competencytestmarking.dichotomy_id in this.$config.getValue('dichotomies')){
				return this.$config.getValue('dichotomies')[this.competencytestmarking.dichotomy_id][type]
			}
			if(type == 'true'){
				return this.$t('pass');
			}
			if(type == 'false'){
				return this.$t('fail');
			}
		}
	}
};
</script>
